import axios from 'axios'
import jwt_decode from 'jwt-decode'
import { useEffect, useState } from 'react'
import ResignInterviewModal from '../Profile/resignInterview/resignInterviewModal'

/** Start of current active resignation period (ms). Prefers created_date; else Mongo ObjectId timestamp. */
function getResignPeriodStartMs(resignData) {
  if (!resignData) return null
  if (resignData.created_date) {
    const t = new Date(resignData.created_date).getTime()
    return Number.isNaN(t) ? null : t
  }
  const idStr = resignData._id != null ? String(resignData._id) : ''
  if (idStr.length === 24 && /^[a-f0-9]+$/i.test(idStr)) {
    const seconds = parseInt(idStr.slice(0, 8), 16)
    if (!Number.isNaN(seconds)) return seconds * 1000
  }
  return null
}

/**
 * After login: if the user has an active resignation row but no submitted exit interview
 * for that resignation, show the mandatory modal. On API errors we fail-open so a broken service does not lock users out.
 */
const ExitInterviewGate = () => {
  const [userId, setUserId] = useState(null)
  const [needsGate, setNeedsGate] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) return
    try {
      const decoded = jwt_decode(token)
      const id = decoded?.user_id ?? decoded?._id ?? decoded?.sub
      if (id != null && id !== '') {
        setUserId(String(id))
      }
    } catch (e) {
      console.warn('ExitInterviewGate: invalid token', e)
    }
  }, [])

  useEffect(() => {
    if (!userId) return

    const run = async () => {
      try {
        const [resignRes, interviewRes] = await Promise.all([
          axios.get(`resigns/${userId}`),
          axios.get(`resignInterview/me/${userId}?limit=1&sort=-createdAt`)
        ])
        const resignOk = resignRes.data?.success !== false
        const resignData = resignRes.data?.data
        const hasActiveResign = resignOk && resignData != null
        const raw = interviewRes.data?.data
        const interviewRows = Array.isArray(raw) ? raw : raw?.docs ?? []
        const latestInterview = interviewRows[0]
        const resignSince = getResignPeriodStartMs(resignData)
        let interviewSubmittedForCurrentResign
        if (resignSince == null) {
          interviewSubmittedForCurrentResign = interviewRows.length > 0
        } else if (!latestInterview) {
          interviewSubmittedForCurrentResign = false
        } else {
          const interviewAt = new Date(latestInterview.createdAt).getTime()
          interviewSubmittedForCurrentResign =
            !Number.isNaN(interviewAt) && interviewAt >= resignSince
        }
        setNeedsGate(hasActiveResign && !interviewSubmittedForCurrentResign)
      } catch (e) {
        console.warn('ExitInterviewGate: check failed, allowing access', e)
        setNeedsGate(false)
      }
    }

    run()
  }, [userId])

  return (
    <ResignInterviewModal gateMode gateActive={needsGate} onCompleted={() => setNeedsGate(false)} />
  )
}

export default ExitInterviewGate
